import { create } from "zustand";

interface IAdSlotsState {
  slots: string[] | null;
  setSlots: (slots: string[]) => void;
}

export const useAdSlotsStore = create<IAdSlotsState>(
  (set) => ({
    slots: null,
    setSlots: (slots: string[]) => set(() => ({ slots })),
  }),
);
